/* Card excerpts: cut to a fixed character budget and append an ellipsis,
   never breaking a word. The budget comes from the "excerpt_length" theme
   setting (default 150). The CSS line-clamp stays on as the no-JS fallback. */
(function () {
    const SELECTOR = '.ff-news-card-excerpt, .ff-hero-excerpt, .gh-card-excerpt';
    const DEFAULT_LENGTH = 150;

    function maxCharacters() {
        const configured = parseInt(document.body.dataset.excerptLength, 10);
        return configured > 0 ? configured : DEFAULT_LENGTH;
    }

    function trim(el, limit) {
        if (!el.dataset.fullExcerpt) {
            el.dataset.fullExcerpt = el.textContent.trim().replace(/\s+/g, ' ');
        }
        const full = el.dataset.fullExcerpt;

        if (full.length <= limit) {
            el.textContent = full;
            return;
        }

        /* Cut back to the last space within the budget so no word is split,
           then drop any punctuation left dangling before the ellipsis. */
        let cut = full.slice(0, limit + 1);
        const lastSpace = cut.lastIndexOf(' ');
        if (lastSpace > 0) {
            cut = cut.slice(0, lastSpace);
        }
        el.textContent = cut.replace(/[\s.,;:!?…-]+$/, '') + '…';
    }

    function trimAll() {
        const limit = maxCharacters();
        document.querySelectorAll(SELECTOR).forEach(function (el) {
            trim(el, limit);
        });
    }

    function init() {
        trimAll();

        /* pagination.js appends the next page's cards into .gh-feed. */
        const feed = document.querySelector('.gh-feed');
        if (feed) {
            new MutationObserver(trimAll).observe(feed, {childList: true});
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
